export default "__VITE_ASSET__DTc1h8kw__"